<script>
export default {
  name: "path-arrow"
}
</script>

<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="path_arrow">
    <path d="M10.4638 7.17733L14.717 11.6165C14.81 11.7327 14.8797 11.8722 14.8797 12.0116C14.8797 12.1511 14.81 12.2905 14.717 12.3835L10.4638 16.8227C10.2546 17.0551 9.88272 17.0551 9.67355 16.8459C9.44113 16.6367 9.44113 16.2881 9.65031 16.0557L13.5549 11.9884L9.65031 7.94431C9.44113 7.73514 9.44113 7.36327 9.67355 7.15409C9.88272 6.94492 10.2546 6.94492 10.4638 7.17733Z" fill="#868C95"/>
  </svg>
</template>

<style scoped>

</style>
